import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { useFormState } from 'react-final-form';
import useDateFnsLocale from 'src/common/hooks/useDateFnsLocale';
import { formatDateRange } from 'src/common/utils/dateHelpers';
import { TripCartFormState } from 'src/listing/types';
import TripCartPanelContent from 'src/trip-cart/components/panel/TripCartPanelContent';
import TripCartCalendar from 'src/trip-cart/components/TripCartCalendar';
import TripCartContentFooter from 'src/trip-cart/components/TripCartContentFooter';
import { useTripCartContext } from 'src/trip-cart/hooks/useTripCartContext';
import Button from 'src/common/components/ButtonDS22';
import TripCartCaptainAndMultiday from 'src/trip-cart/components/TripCartCaptainAndMultiDay';
import useBookingMotivatorsContext from 'src/common/providers/useBookingMotivators';
import Typography from 'src/common/components/Typography';
import IconDS22 from 'src/common/components/IconDS22';
import styles from './TripCartPanelCalendar.module.scss';

const TripCartPanelCalendar: FC = () => {
  const [t] = useTranslation('listing-page');
  const [tCommon] = useTranslation('common');
  const { isDateUnavailable } = useBookingMotivatorsContext();
  const { values: { formSelectedDates, isMultiDay } } = useFormState<TripCartFormState>();
  const { closePanel } = useTripCartContext();
  const [startDate, endDate] = formSelectedDates;
  const dateLocale = useDateFnsLocale();
  const dateRange = formatDateRange(
    startDate,
    endDate,
    dateLocale,
  ) ?? t('trip-cart--drawer-title--date-duration');

  const dateIsUnavailable = isDateUnavailable(formSelectedDates, isMultiDay);

  return (
    <TripCartPanelContent title={dateRange}>
      <div className={styles.root}>
        <TripCartCaptainAndMultiday />
        <TripCartCalendar />
      </div>
      <TripCartContentFooter>
        {dateIsUnavailable && (
          <div className={styles.dateUnavailable}>
            <IconDS22 id="info" size="s" />
            <Typography type="span" size="body-s">
              {tCommon('booking-motivator--unavailable--description', { count: isMultiDay ? 2 : 1 })}
            </Typography>
          </div>
        )}
        <Button
          variant="secondary"
          onClick={() => closePanel()}
        >
          {t('trip-cart--action-done')}
        </Button>
      </TripCartContentFooter>
    </TripCartPanelContent>
  );
};

export default TripCartPanelCalendar;
